import { css } from '@emotion/react';
import settings from '@settings';

export const footerContainer = settings.mq({
	width: '100%',
	position: 'relative',
	padding: settings.padding.medium,
	// borderTop: `1px solid ${settings.colors.grey}`,
	backgroundColor: settings.colors.dark,
	display: ['flex', 'flex', 'none'],
	flexDirection: 'column',
	justifyContent: 'space-between',
	alignItems: 'center',
	'p': {
		fontSize: settings.fontSize.tiny,
		color: settings.colors.white + ' !important',
		textAlign: 'center !important'
	},
	'a': {
		fontSize: settings.fontSize.tiny,
		color: settings.colors.white + ' !important'
	}
});

export const lastContainer = css({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	flexDirection: 'row',
	padding: settings.padding.large,
	color: settings.colors.light,
	borderTop: `1px solid ${settings.colors.grey}`,
	backgroundColor: settings.colors.dark,
	gap: settings.sizes.medium,
	'a': {
		textDecoration: 'none',
	}
});

export const footerInfoContainer = css({
	flex: '0 0 50%',
	// marginTop: settings.sizes.extraLarge,
	
});

export const footerInfoHeadline = css({
	color: settings.colors.lightgrey + ' !important',
	fontSize: settings.fontSize.tiny + ' !important',
	textTransform: 'uppercase',
	marginTop: settings.sizes.medium,
	marginBottom: settings.sizes.small + ' !important',
});

export const addressContainer = css({
	flex: '0 0 50%',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	alignItems: 'center',
	gap: settings.sizes.small
});